import { Routes, Route, Navigate } from "react-router-dom";
import { ProtectedRoute } from "../hooks/useAuth";
import Dashboard from "../pages/Dashboard";
import AdminPanel from "../pages/AdminPanel";
import BadgesPage from "../pages/BadgesPage";
import ReportsPage from "../pages/ReportsPage";
import SettingsPage from "../pages/SettingsPage";
import Technicians from "../pages/Technicians";
import Users from "../pages/Users";
import Sops from "../pages/Sops";
import BadgeLists from "../pages/BadgeLists";
import BadgeCycles from "../pages/BadgeCycles";
import AddNewBadgeCycle from "../pages/AddNewBadgeCycle";
import DoseReportsList from "../pages/DoseReportsList";
import BadgeCycleForm from '../pages/BadgeCycleForm';

export default function AppRoutes() {
     return (
          <Routes>
               <Route path="/" element={<Navigate to="/dashboard" replace />} />
               <Route path="/dashboard" element={<Dashboard />} />

               <Route
                    path="/badges"
                    element={
                         <ProtectedRoute allowedRoles={['TECHNICIAN']}>
                              <BadgesPage />
                         </ProtectedRoute>
                    }
               />

               <Route
                    path="/settings"
                    element={
                         <ProtectedRoute allowedRoles={['ADMIN', 'SUPER_ADMIN', 'TECHNICIAN']}>
                              <SettingsPage />
                         </ProtectedRoute>
                    }
               />
               <Route
                    path="/sops"
                    element={
                         <ProtectedRoute allowedRoles={['ADMIN', 'SUPER_ADMIN', 'TECHNICIAN']}>
                              <Sops />
                         </ProtectedRoute>
                    }
               />


               <Route
                    path="/reports"
                    element={
                         <ProtectedRoute allowedRoles={['ADMIN', 'QUALITY_ADMIN', 'SUPER_ADMIN']}>
                              <ReportsPage />
                         </ProtectedRoute>
                    }
               />

               <Route
                    path="/admin"
                    element={
                         <ProtectedRoute allowedRoles={['ADMIN', 'QUALITY_ADMIN', 'SUPER_ADMIN']}>
                              <AdminPanel />
                         </ProtectedRoute>
                    }
               />

               <Route
                    path="/technicians"
                    element={
                         <ProtectedRoute allowedRoles={['ADMIN', 'QUALITY_ADMIN', 'SUPER_ADMIN']}>
                              <Technicians />
                         </ProtectedRoute>
                    }
               />

               <Route
                    path="/badge-cycles"
                    element={
                         <ProtectedRoute allowedRoles={['ADMIN', 'QUALITY_ADMIN', 'SUPER_ADMIN']}>
                              <BadgeCycles />
                         </ProtectedRoute>
                    }
               />
               <Route
                    path="/badge-cycles/new"
                    element={
                         <ProtectedRoute allowedRoles={['ADMIN', 'QUALITY_ADMIN', 'SUPER_ADMIN']}>
                              <BadgeCycleForm />
                              {/* <AddNewBadgeCycle /> */}
                         </ProtectedRoute>
                    }
               />
               <Route
                    path="/addNewBadgeCycle"
                    element={
                         <ProtectedRoute allowedRoles={['ADMIN', 'QUALITY_ADMIN', 'SUPER_ADMIN']}>
                              <AddNewBadgeCycle />
                         </ProtectedRoute>
                    }
               />

               <Route
                    path="/badge-lists"
                    element={
                         <ProtectedRoute allowedRoles={['ADMIN', 'QUALITY_ADMIN', 'SUPER_ADMIN']}>
                              <BadgeLists />
                         </ProtectedRoute>
                    }
               />
               <Route
                    path="/dose-reports-list"
                    element={
                         <ProtectedRoute allowedRoles={['ADMIN', 'QUALITY_ADMIN', 'SUPER_ADMIN']}>
                              <DoseReportsList />
                         </ProtectedRoute>
                    }
               />

               <Route
                    path="/users"
                    element={
                         <ProtectedRoute allowedRoles={['SUPER_ADMIN']}>
                              <Users />
                         </ProtectedRoute>
                    }
               />

               <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
     );
}
